import { MapState } from "../types/store-schema";

/**
 * Sets the map object tile ignoreZoomOptimisation value.
 */
export function setMapObjectTilesZoomOptimisation(initialState: MapState, tileType: "comments" | "objects", ignoreZoomOptimisation: boolean): string {
    const remoteMapObjectsTileSourceUrl = initialState?.tileSources?.value?.[tileType]?.tiles?.[0].tiles?.[0];
    if (remoteMapObjectsTileSourceUrl == null) {
        return null;
    }
    const [baseUrl] = remoteMapObjectsTileSourceUrl.split("?");
    return `${baseUrl}?ignoreZoomOptimisation=${ignoreZoomOptimisation}`;
}
